module.exports = __webpack_public_path__ + "static/img/sql-server.a6de7430.png";